import { render } from "./PaymentNotices.vue?vue&type=template&id=8ed2a8c0"
import script from "./PaymentNotices.vue?vue&type=script&lang=js"
export * from "./PaymentNotices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__